import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../../core/services/ApiService';
import { IActiveReleaseNoteDisplay, IReleaseNote } from '../interfaces/IReleaseNote';
import { IResponse } from '../../../../core/interfaces/IResponse';
import { HttpParams } from '@angular/common/http';
import { ReleaseNoteDisplayKind } from '../enums/ReleaseNoteDisplayKind';

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesService {

  private readonly _basePath = '/dashboard';
  private readonly _apiService = inject(ApiService);

  public getActiveReleaseNoteForCash(): Observable<IReleaseNote> {
    return this._apiService.get(`${this._basePath}/release-note`).pipe(
      map((response: IResponse<IReleaseNote>) => response.data)
    );
  }

  public getActiveDisplay(): Observable<IActiveReleaseNoteDisplay> {
    return this._apiService.get(`${this._basePath}/release-notes/active`).pipe(
      map((response: IResponse<IActiveReleaseNoteDisplay>) => response.data)
    );
  }

  public markSeen(id: number, kind: ReleaseNoteDisplayKind): Observable<void> {
    return this._apiService.post(`${this._basePath}/release-notes/${id}/seen`, { kind });
  }

  public downloadReleaseNote(id: number): Observable<string> {
    const params = new HttpParams().set('id', id);
    return this._apiService.get(`${this._basePath}/release-note-file-url`, params).pipe(
      map((response: string) => response)
    );
  }
}
